(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-premium-header]').forEach((header) => {
    const menus = header.querySelectorAll('.phead-submenu, .phead-mobile');
    const closeMenu = (menu, restoreFocus = false) => {
      menu.open = false;
      if (restoreFocus) menu.querySelector('summary')?.focus();
    };
    menus.forEach((menu) => {
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          event.preventDefault();
          event.stopPropagation();
          closeMenu(menu, true);
        }
      });
      menu.addEventListener('focusout', (event) => {
        if (!menu.contains(event.relatedTarget)) closeMenu(menu);
      });
      menu.addEventListener('toggle', () => {
        if (menu.open) menus.forEach((other) => { if (other !== menu) closeMenu(other); });
      });
    });
    document.addEventListener('click', (event) => {
      menus.forEach((menu) => { if (!menu.contains(event.target)) closeMenu(menu); });
    });
    window.matchMedia('(max-width: 1180px)').addEventListener('change', () => menus.forEach((menu) => closeMenu(menu)));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.pp');

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const variantsNode = root.querySelector('[data-variants-json]');
      let variants = [];
      try {
        variants = JSON.parse(variantsNode?.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      const currency = root.dataset.currency || 'EUR';
      const money = (value) => {
        const amount = Number(value || 0) / 100;
        try {
          return new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(amount);
        } catch (error) {
          return amount.toFixed(2) + ' ' + currency;
        }
      };

      const price = root.querySelector('[data-product-price]');
      const compare = root.querySelector('[data-product-compare]');
      const saving = root.querySelector('[data-product-saving]');
      const variantId = root.querySelector('[data-variant-id]');
      const addButton = root.querySelector('[data-add-to-cart]');
      const addLabel = root.querySelector('[data-add-label]');
      const stickyPrice = root.querySelector('[data-sticky-price]');
      const stickySubmit = root.querySelector('[data-sticky-submit]');
      const stickyLabel = root.querySelector('[data-sticky-label]');
      const form = root.querySelector('.pp__form');

      const showMedia = (mediaId) => {
        if (!mediaId) return;
        const items = root.querySelectorAll('[data-media-id]');
        const thumbs = root.querySelectorAll('[data-gallery-thumb]');
        let found = false;

        items.forEach((item) => {
          const active = String(item.dataset.mediaId) === String(mediaId);
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', active ? 'false' : 'true');
          item.inert = !active;
          if (!active) item.querySelectorAll('video').forEach((video) => video.pause());
          if (active) found = true;
        });

        if (!found) return;

        const status = root.querySelector('[data-gallery-status]');
        const mediaIndex = Array.from(items).findIndex((item) => String(item.dataset.mediaId) === String(mediaId));
        if (status) status.textContent = root.dataset.mediaStatusTemplate.replace('[index]', String(mediaIndex + 1)).replace('[total]', String(items.length));

        thumbs.forEach((thumb) => {
          const active = String(thumb.dataset.galleryThumb) === String(mediaId);
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const activeMediaIds = () => Array.from(root.querySelectorAll('[data-media-id]')).map((item) => item.dataset.mediaId);

      const moveGallery = (direction) => {
        const ids = activeMediaIds();
        if (ids.length < 2) return;
        const active = root.querySelector('[data-media-id].is-active');
        const currentIndex = Math.max(0, ids.indexOf(active?.dataset.mediaId));
        const nextIndex = (currentIndex + direction + ids.length) % ids.length;
        showMedia(ids[nextIndex]);
      };

      root.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
        button.addEventListener('click', () => showMedia(button.dataset.galleryThumb));
      });

      root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => moveGallery(-1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => moveGallery(1));

      const selectedOptions = () => Array.from(root.querySelectorAll('.pp__option')).map((fieldset) => {
        return fieldset.querySelector('[data-option-value]:checked')?.value || '';
      });

      const findVariant = () => {
        if (!variants.length) return null;
        const selected = selectedOptions();
        if (!selected.length) {
          return variants.find((variant) => variant.id == variantId?.value) || variants[0];
        }
        return variants.find((variant) => {
          const options = Array.isArray(variant.options) ? variant.options : [];
          return selected.every((value, index) => options[index] === value);
        });
      };

      const updateVariant = () => {
        const variant = findVariant();
        if (!variant) {
          if (addButton) addButton.disabled = true;
          if (addLabel) addLabel.textContent = 'Indisponible';
          if (stickySubmit) stickySubmit.disabled = true;
          if (stickyLabel) stickyLabel.textContent = 'Indisponible';
          return;
        }

        if (variantId) variantId.value = variant.id;
        if (price) price.textContent = money(variant.price);
        if (stickyPrice) stickyPrice.textContent = money(variant.price);

        const comparePrice = Number(variant.compare_at_price || 0);
        const salePrice = Number(variant.price || 0);
        const onSale = comparePrice > salePrice;

        if (compare) {
          compare.textContent = onSale ? money(comparePrice) : '';
          compare.classList.toggle('is-hidden', !onSale);
        }

        if (saving) {
          saving.textContent = onSale ? 'Économisez ' + money(comparePrice - salePrice) : '';
          saving.classList.toggle('is-hidden', !onSale);
        }

        const available = Boolean(variant.available);
        if (addButton) addButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? 'Ajouter au panier' : 'Indisponible';
        if (stickySubmit) stickySubmit.disabled = !available;
        if (stickyLabel) stickyLabel.textContent = available ? 'Ajouter' : 'Indisponible';

        root.querySelectorAll('.pp__option').forEach((fieldset) => {
          const selected = fieldset.querySelector('[data-option-value]:checked');
          const text = fieldset.querySelector('[data-selected-option]');
          if (selected && text) text.textContent = selected.value;
        });

        if (variant.featured_media && variant.featured_media.id) {
          showMedia(variant.featured_media.id);
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      };

      root.querySelectorAll('[data-option-value]').forEach((input) => {
        input.addEventListener('change', updateVariant);
      });

      const qty = root.querySelector('[data-qty-input]');
      root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
        if (!qty) return;
        qty.value = String(Math.max(1, Number(qty.value || 1) - 1));
      });
      root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
        if (!qty) return;
        qty.value = String(Math.max(1, Number(qty.value || 1) + 1));
      });

      stickySubmit?.addEventListener('click', () => {
        if (!form || !addButton || addButton.disabled) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(addButton);
        } else {
          addButton.click();
        }
      });

      root.querySelectorAll('[data-copy-code]').forEach((button) => {
        button.addEventListener('click', async () => {
          const code = button.dataset.copyCode;
          try {
            await navigator.clipboard.writeText(code);
            root.querySelector('[data-copy-status]').textContent = root.dataset.copySuccess;
            const original = button.textContent;
            button.textContent = 'Code copié';
            window.setTimeout(() => {
              button.textContent = original;
            }, 1800);
          } catch (error) {
            button.textContent = code;
            root.querySelector('[data-copy-status]').textContent = root.dataset.copyFailure + ' ' + code;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
